import React, { useMemo } from 'react';
import { TelegramIconRound } from '@cp/ds/src/icons/social/round/telegramRound';
// import { ViberIconRound } from '@cp/ds/src/icons/social/round/viberRound';
import { VkIconRound } from '@cp/ds/src/icons/social/round/vkRound';
import { WhatsAppIconRound } from '@cp/ds/src/icons/social/round/whatsAppRound';
import { useConfig } from '@cp/shared/config';
import { SocialMediaList } from 'src/shared/ui/socialMediaList';

export const SupportSocialMediaContacts: React.FC = () => {
  const config = useConfig();
  const contactData = useMemo(
    () =>
      [
        // {
        //   icon: ViberIconRound,
        //   href: config.get('SUPPORT_VIBER') as string,
        //   name: 'Viber',
        // },
        {
          icon: WhatsAppIconRound,
          href: config.get('SUPPORT_WHATSAPP') as string,
          name: 'WhatsApp',
        },

        {
          icon: TelegramIconRound,
          href: config.get('SUPPORT_TELEGRAM') as string,
          name: 'Telegram',
        },

        {
          icon: VkIconRound,
          href: config.get('SUPPORT_VK') as string,
          name: 'Вконтакте',
        },
      ].filter((item) => Boolean(item.href)),
    [config],
  );
  return <SocialMediaList media={contactData} />;
};
